import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const sitemapSections = [
  {
    title: 'Main Pages',
    links: [
      { path: '/', label: 'Home', desc: 'Welcome to Glossop & District Round Table 916' },
      { path: '/news', label: 'News', desc: 'Latest news and updates from Glossop Round Table' },
      { path: '/contact', label: 'Contact Us', desc: 'Address, email and contact form for enquiries' },
    ],
  },
  {
    title: 'About Us',
    links: [
      { path: '/about', label: 'About Us', desc: 'Learn about Round Table — fun, friendship and fundraising since 1927' },
      { path: '/charities', label: 'Charities We Support', desc: 'Local and national good causes supported by Round Table 916 fundraising' },
      { path: '/socials', label: 'Socials', desc: 'Members\u2019 weekends away, the Woodland Games and other Round Table socials' },
      { path: '/social-calendar', label: 'Social Calendar 2026', desc: 'Every social, meeting and big weekend from May 2026 through April 2027' },
    ],
  },
  {
    title: 'Membership',
    links: [
      { path: '/membership', label: 'Join Us', desc: 'Information on joining Round Table and contact form' },
      { path: '/member-benefits', label: 'Member Benefits', desc: 'Exclusive benefits for Round Table members' },
    ],
  },
  {
    title: 'Events',
    links: [
      { path: '/events', label: 'Events', desc: 'Community events raising money for local charities' },
      { path: '/heritage-programme', label: 'Glossop Heritage Weekend', desc: '3-day heritage weekend with live entertainment, parades and more' },
      { path: '/glossfest', label: 'GlossFest', desc: 'Music festival in the heart of Glossop, Norfolk Square' },
      { path: '/bonfire', label: 'Bonfire Night', desc: 'Glossop Bonfire & Fireworks Spectacular in Manor Park' },
      { path: '/volunteer', label: 'Volunteer', desc: 'Lend a hand at Round Table events — Heritage Weekend, GlossFest and Bonfire Night' },
      { path: '/supporters', label: 'Our Supporters', desc: 'Local businesses and sponsors backing Round Table 916 events' },
    ],
  },
  {
    title: 'Information',
    links: [
      { path: '/sitemap', label: 'Sitemap', desc: 'Full site map of all pages' },
    ],
  },
];

export default function SitemapPage() {
  return (
    <div data-testid="sitemap-page">
      <SEO
        title="Sitemap"
        description="Full sitemap of the Glossop & District Round Table 916 website. Find all pages including events, membership, news, and community information."
        path="/sitemap"
        keywords={['sitemap', 'Glossop Round Table pages', 'site map']}
      />

      <div className="pt-28 sm:pt-32 pb-20 sm:pb-28 bg-white min-h-screen">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#F0A500] block mb-4">Navigation</span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0A0A0A] mb-12">
            Sitemap
          </h1>

          <div className="space-y-12">
            {sitemapSections.map((section) => (
              <div key={section.title}>
                <h2 className="text-xs font-bold uppercase tracking-[0.2em] text-[#F0A500] mb-4 pb-2 border-b border-zinc-200">
                  {section.title}
                </h2>
                <ul className="space-y-3">
                  {section.links.map((link) => (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        data-testid={`sitemap-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                        className="group flex items-start gap-3"
                      >
                        <span className="text-base font-semibold text-[#0A0A0A] group-hover:text-[#F0A500] transition-colors">
                          {link.label}
                        </span>
                        <span className="text-sm text-[#52525B] pt-0.5">
                          — {link.desc}
                        </span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
